import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from '@/components/ui/select';
import { cn } from '@/lib/utils';

export interface SelectFilterOption {
  value: string;
  label: string;
}

export interface SelectFilterProps {
  label: string;
  value: string | null;
  onChange: (value: string | null) => void;
  options: SelectFilterOption[];
  placeholder?: string;
  className?: string;
  /** Compact mode hides the uppercase label (for inset toolbars). */
  compact?: boolean;
  /** When true, the trigger stretches to fill its container instead of using the fixed 180px width. */
  fluid?: boolean;
}

const ALL_SENTINEL = '__all__';

export function SelectFilter({
  label,
  value,
  onChange,
  options,
  placeholder = 'All',
  className,
  compact = false,
  fluid = false,
}: SelectFilterProps) {
  return (
    <div className={cn('flex flex-col gap-1.5', fluid && 'w-full', className)}>
      {!compact ? (
        <span className="text-meta-sm tracking-label font-medium text-neutral-500 uppercase">
          {label}
        </span>
      ) : null}
      <Select
        value={value ?? ALL_SENTINEL}
        onValueChange={(v) => {
          onChange(v === ALL_SENTINEL ? null : v);
        }}
      >
        <SelectTrigger
          aria-label={label}
          className={cn('h-10 min-w-40', fluid ? 'w-full' : compact ? 'w-40' : 'w-45')}
        >
          <SelectValue placeholder={placeholder} />
        </SelectTrigger>
        <SelectContent>
          <SelectItem value={ALL_SENTINEL}>{placeholder}</SelectItem>
          {options.map((opt) => (
            <SelectItem key={opt.value} value={opt.value}>
              {opt.label}
            </SelectItem>
          ))}
        </SelectContent>
      </Select>
    </div>
  );
}
